import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack, IoEyeOutline, IoEyeOffOutline } from 'react-icons/io5';
import { useThemeStore } from '../../../stores/useThemeStore';
import logoLight from '../../../assets/MainLogo/MKraftLogoLight.png';
import logoDark from '../../../assets/MainLogo/MKraftLogoDark.png';
import './CreateNewPassword.css';

const CreateNewPassword: React.FC = () => {
  const navigate = useNavigate();
  const { theme } = useThemeStore();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSubmit = () => {
    console.log('Password created successfully');
    // Navigate to login page after password creation
    navigate('/login');
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  // Select logo based on theme
  const logo = theme === 'dark' ? logoDark : logoLight ;

  return (
    <div className="create-password-container">
      <div className="create-password-header">
        <div className="create-password-logo">
          <img src={logo} alt="Multiplierskraft Logo" className="create-password-logo-image" />
        </div>
      </div>

      <div className="create-password-card">

        <h1 className="create-password-title">Create New Password</h1>
        <p className="create-password-subtitle">Set your new & strong password for security.</p>

        <div className="create-password-form">
          <div className="create-password-form-group">
            <label className="create-password-label" htmlFor="password">
              Enter Password
            </label>
            <div className="create-password-input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                className="create-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your new password"
              />
              <button
                type="button"
                className="create-password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                aria-label="Toggle password visibility"
              >
                {showPassword ? <IoEyeOffOutline size={20} /> : <IoEyeOutline size={20} />}
              </button>
            </div>
          </div>

          <div className="create-password-form-group">
            <label className="create-password-label" htmlFor="confirmPassword">
              Re-enter Password
            </label>
            <div className="create-password-input-wrapper">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                id="confirmPassword"
                className="create-password-input"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm your new password"
              />
              <button
                type="button"
                className="create-password-toggle"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                aria-label="Toggle password visibility"
              >
                {showConfirmPassword ? <IoEyeOffOutline size={20} /> : <IoEyeOutline size={20} />}
              </button>
            </div>
          </div>

          <button
            type="button"
            onClick={handleSubmit}
            className="create-password-submit-button"
          >
            Create Password
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateNewPassword;
